import React from 'react';
import { AppleIcon, PlayStoreIcon } from './PlatformIcons';

export const APP_STORE_URL = 'https://apps.apple.com/in/app/workloop-chats/id6786167905';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=chat.workloop.app';

export const AppStoreBadge = ({ className = '' }) => (
  <a
    href={APP_STORE_URL}
    className={`wl-store-badge wl-store-badge--apple ${className}`.trim()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download WorkLoop on the App Store"
  >
    <AppleIcon className="wl-store-badge__mark" />
    <span className="wl-store-badge__copy">
      <span className="wl-store-badge__eyebrow">Download on the</span>
      <span className="wl-store-badge__name">App Store</span>
    </span>
  </a>
);

export const GooglePlayBadge = ({ className = '' }) => (
  <a
    href={PLAY_STORE_URL}
    className={`wl-store-badge wl-store-badge--play ${className}`.trim()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Get WorkLoop on Google Play"
  >
    <PlayStoreIcon className="wl-store-badge__mark" />
    <span className="wl-store-badge__copy">
      <span className="wl-store-badge__eyebrow">Get it on</span>
      <span className="wl-store-badge__name">Google Play</span>
    </span>
  </a>
);

export const StoreBadgeRow = ({ className = '' }) => (
  <div className={`wl-store-badges ${className}`.trim()}>
    <AppStoreBadge />
    <GooglePlayBadge />
  </div>
);
